import React from 'react';
import { Input } from '@/components/ui/input';
import { useTranslation } from 'react-i18next';

interface ContactActionBarProps {
  totalCount: number;
  filteredCount: number;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export const ContactActionBar: React.FC<ContactActionBarProps> = ({
  totalCount,
  filteredCount,
  searchQuery,
  setSearchQuery,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row items-center justify-end gap-2 w-full md:w-auto">
      {filteredCount !== totalCount && (
        <span className="text-sm text-muted-foreground hidden sm:inline">
          {t('common.actions.showing.translation', {
            count: filteredCount,
            total: totalCount,
          })}
        </span>
      )}

      <Input
        type="text"
        variant="borderless"
        placeholder={t('contacts.search_placeholder.translation')}
        value={searchQuery}
        onChange={e => setSearchQuery(e.target.value)}
        className="w-full bg-card md:w-[250px]"
      />
    </div>
  );
};

export default ContactActionBar;
